// The request a receipt paid for, as a quiet chip that opens it. Shown on the
// reconcile board's matched rows and in the receipt peek.

import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '../components/ui/Tooltip';
import type { ReceiptRequisitionLink } from './types';

export function requisitionChipLabel(r: ReceiptRequisitionLink): string {
  return r.approved_by_name ? `${r.req_number}, approved by ${r.approved_by_name}` : r.req_number;
}

const RequisitionChips: React.FC<{ requisitions?: ReceiptRequisitionLink[] | null; className?: string }> = ({
  requisitions,
  className = '',
}) => {
  if (!requisitions || !requisitions.length) return null;
  return (
    <span className={`inline-flex min-w-0 flex-wrap gap-1 ${className}`}>
      {requisitions.map((r) => {
        const label = requisitionChipLabel(r);
        return (
          <Tooltip key={r.id} label={label}>
            <Link
              to={`/requisitions/${r.id}`}
              className="inline-flex min-w-0 max-w-[16rem] items-center rounded-full bg-surface-container-highest px-2.5 py-0.5 text-[11px] font-medium text-on-surface-variant transition-colors duration-150 hover:text-on-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 motion-reduce:transition-none"
            >
              <span className="truncate">{label}</span>
            </Link>
          </Tooltip>
        );
      })}
    </span>
  );
};

export default RequisitionChips;
